module.exports = __webpack_public_path__ + "img/icon_exit.935de36d.svg";